import { Message } from 'botframework-directlinejs';

import {
  type IStructuredLogBase,
  type ICreateStructuredLogParams,
  TCreateStructuredLogBase,
} from '../types/structured-log-types';

const getActivityText = (activity: Message): IStructuredLogBase['activityText'] => {
  if (activity.text === 'StaticMessages') {
    return activity.value as unknown as string;
  }
  return activity.text as string;
};

const getResponder = (
  activity: ICreateStructuredLogParams['activity'],
  botServiceConfig: ICreateStructuredLogParams['botServiceConfig'],
): IStructuredLogBase['responder'] => {
  if (activity.value === 'LiveAgentMessage') {
    return 'Agent';
  }
  if (activity.from.name === botServiceConfig.username) {
    if (activity.channelId === 'directline') {
      return 'User';
    }
    return 'UserWithAgent';
  }
  return 'Copilot';
};

/**
 * `createStructuredLogBase` is a utility function that creates a structured log base object
 * @param params - parameters to create a structured log base object
 * @returns structured log base object
 */
export const createStructuredLogBase: TCreateStructuredLogBase = (params) => {
  const { activity, botServiceConfig, locale } = params;

  return {
    conversationId: activity.conversation?.id as string,
    timestamp: new Date().toUTCString(),
    uid: botServiceConfig.userid,
    cid: botServiceConfig.customerId as string,
    aid: botServiceConfig.accountId as string,
    product: botServiceConfig.productName,
    activityType: 'unknown',
    activityText: getActivityText(activity as Message),
    responder: getResponder(activity, botServiceConfig),
    locale: locale!,
    pilots: activity.value?.AdditionalContext?.Pilots || {},
  };
};
